/**
 * package: com.inq.flash.client.chatskins
 * class: OpenerScript
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.OpenerScript = function() {
	// When Application is reused then needs to reset this flag
	// Scenario when required:
	// 1) Start chat in DIV mode 2) Move it to PERSISTENT 3) Close chat 4) Start again DIV chat
	// Without this fix the openers are blocked.
	com.inq.flash.client.chatskins.OpenerScript.resetOpenersStopped();
	this.reset();
};
$hxClasses['com.inq.flash.client.chatskins.OpenerScript'] = com.inq.flash.client.chatskins.OpenerScript;
/** @private @type {Array} */
com.inq.flash.client.chatskins.OpenerScript.__name__ = ["com","inq","flash","client","chatskins","OpenerScript"];

/**
 * resetOpenersStopped
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function resetOpenersStopped()
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.OpenerScript.resetOpenersStopped = function() {
	com.inq.flash.client.chatskins.OpenerScript.bOpenersStopped = false;
};


/**
 * openerScriptsLoaded
 *
 * @this com.inq.flash.client.chatskins.OpenerScript
 * @param {com.inq.events.Event}  event 
 * @return {void}
 */
com.inq.flash.client.chatskins.OpenerScript.prototype.openerScriptsLoaded = function(event) {
	if (this.runOnce || com.inq.flash.client.chatskins.SkinControl.isChatEngaged()
		|| com.inq.flash.client.chatskins.SkinControl.getApplicationController().isFirstMessageSent()
	) {
		return;
	}
	this.runOnce = true;

	/** Assume that chat window is fully rendered and want to set the focus on the text input
	 *   text input should have focus now if it doesn't have it. So opener script is not blocked from read.
	 * @type {com.inq.ui.TextInput}
	 */
	var ti = com.inq.flash.client.chatskins.SkinControl.getTextInputField();

	/**
	 * If a user clicked the C2C button the launchType would equal "C2C"
	 * If a business rule timer opened the chat "proactively" after a certain amount of time the
	 * chat type would equal "POPUP"
	 * We can not change the focus if the user did not click the C2C button because it is an
	 * accessibility violation because the user could be using a screen-reader to listen to
	 * elements on the page, then suddenly the chat opens up and changes the focused element
	 * without asking the user.
	 * @type {boolean}
	 */
	var c2cClicked = com.inq.flash.client.control.FlashVars.get("launchType") === "C2C";

	if (c2cClicked && ti) {
		/**
		 * RTDEV-15839
		 * Only set text input focus if the skin does not have "setFocusOnClose" property defined.
		 */
		if (!Application.setFocusToBtnCloseOnOpen  && !com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
			ti.setFocus();
		}
	}
	var sOpeners = this.scriptLoader.data;
	this.scriptLoader = null;
	if (sOpeners == null || sOpeners == "") {
		this.displayDefaultOpenerScript();
		return;
	}

	/** @type {Xml} */
	var scriptXML = Xml.parse(sOpeners);
	/** @type {Iterator} */
	var it = scriptXML.firstElement().elements();
	/** @type {Array} */
	var aOpeners = new Array();
	/** @type {number} */
	var i = 0;
	/** @type {?string} */
	var adaIntroduction = com.inq.flash.client.chatskins.OpenerScript.getAdaIntroduction();
	if (adaIntroduction != null && !Application.IsPersistent()) {
		this.displayadaIntroduction(adaIntroduction);
	}

	while (it.hasNext()) {
		var x1 = it.next();
		/** @type {string} */
		var name = x1.getNodeName();
		if ("script" == name) {
			aOpeners[i++] = com.inq.utils.StringUtil.htmlDecode(x1.firstChild().toString());
		}
	}
	if (null == this.scripts) {
		this.scripts = [];
	}
	for (var j = 0; j < aOpeners.length; j++) {
		if (aOpeners[j] != "") {
			this.scripts[this.scriptCnt++] = aOpeners[j];
		}
	}

	if (this.scriptCnt > 0) {
		var scriptShown = com.inq.flash.client.control.PersistenceManager.GetValue(OPENER_SCRIPT_COUNT, 0);
		if (scriptShown) {
			while (scriptShown-- > 0) {
				this.displayScriptLine();
			}
			this.startOpenersTimer();
		} else {
			this.displayScript();
		}
	}
};

com.inq.flash.client.chatskins.OpenerScript.getAdaIntroduction = function(event) {
	var adaIntroduction = com.inq.utils.Util.getConfig("adaIntroduction", null);
	if (adaIntroduction != null)
	{
		adaIntroduction = adaIntroduction.replace("{accesskey}", getBrowserAccessKey());
	}

	return adaIntroduction;

	function getBrowserAccessKey() {
		var accessKey = "Alt";
		if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
			accessKey = "Shift Alt";
		} else if ((navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1 &&  navigator.userAgent.indexOf('Android') == -1) && navigator.platform.toUpperCase().indexOf('MAC')>=0 )
		{
			accessKey = "Control";
		}
		return accessKey;
	}
}

/**
 * Handles failing of opener scripts loading
 * @param {com.inq.events.Event} event
 */
com.inq.flash.client.chatskins.OpenerScript.prototype.openerScriptFailed = function(event) {
	com.inq.flash.client.control.FlashPeer.logErrorToServer("Error while loading opener scripts.");
	if (!com.inq.flash.client.chatskins.SkinControl.isChatEngaged()
		&& !com.inq.flash.client.chatskins.SkinControl.getApplicationController().isFirstMessageSent()
	) {
		this.displayDefaultOpenerScript();
	}
};

/**
 * Displays default opener script
 */
com.inq.flash.client.chatskins.OpenerScript.prototype.displayDefaultOpenerScript = function() {
	this.scripts[this.scriptCnt++] = this.DEFAULT_OPENER;
	this.displayScriptLine();
};

/**
 * getOpenerScripts
 *
 * $type TFun([],TEnum(Void,[]))
 * private function getOpenerScripts():Void
 * @private
 * @this com.inq.flash.client.chatskins.OpenerScript
 * @return {void}
 */
com.inq.flash.client.chatskins.OpenerScript.prototype.getOpenerScripts = function () {
	// Skip opener scripts if we are in survey mode.
	if (com.inq.flash.client.control.FlashPeer.isCEAPIPostChatSurveyMode()) {
		return;
	}

	var opID = com.inq.flash.client.control.FlashVars.getValue("openerID");
	var opName = com.inq.flash.client.control.FlashVars.getValue("openerName");
	var siteID = com.inq.flash.client.control.FlashVars.getValue("siteID");

	if ((opID <= 0 && !opName) || !siteID) {
		return;
	}

    //RTDEV-4877 Added siteID parameter to load openers only from current site.
    //Also support loading by name. Name should be unique per new changes
	/** @type {string} */
	var sTagServerURL = Std.string(com.inq.flash.client.control.FlashVars.getValue("tagServerBaseURL"))
		+ "tagserver/scripts/getScript?js=yes&siteID=" + siteID;
    if(opName) {
        sTagServerURL += "&scriptName=" + Std.string(opName);
    } else {
        sTagServerURL += "&scriptID=" + Std.string(opID);
    }
	/** @type {string} */
	this.scriptLoader = new com.inq.net.URLLoader();
	/** @type {com.inq.net.URLRequest} */
	var scriptRequest = new com.inq.net.URLRequest(sTagServerURL);
	this.scriptLoader.addEventListener(com.inq.events.Event.NETWORK_ERROR,$bind(this,this.openerScriptFailed));
	this.scriptLoader.addEventListener(com.inq.events.Event.BAD_REQUEST, $bind(this, this.openerScriptFailed));
	this.scriptLoader.addEventListener(com.inq.events.Event.COMPLETE,$bind(this,this.openerScriptsLoaded));
	this.scriptLoader.load(scriptRequest);
};

/**
 * Display opener script in chat. If needed push it in queue.
 *
 * @public
 * @return {void}
 */
com.inq.flash.client.chatskins.OpenerScript.prototype.displayScriptLine = function() {
	/** @type {string} */
	var agentName = com.inq.flash.client.control.FlashVars.getValue("agentName");
    if (com.inq.utils.Util.isDefaultAgentAlias()) {
        agentName = com.inq.utils.Util.getConfig("defaultAgentAlias", "&nbsp;");
    }

	var sequenceNumber = this.scriptCur;

	/** @type {string} */
	var msg = this.scripts[this.scriptCur++];

	/** @type {object} */
	var expressionObject = com.inq.flash.client.chatskins.SkinControl.checkForSpecialExpression(msg);
	msg = expressionObject.text;
	com.inq.flash.client.chatskins.SkinControl.AddOpenerToChatWindow(agentName,msg,com.inq.flash.client.chatskins.ChatTextArea.AGENT,-1,expressionObject.expressionList);
	com.inq.flash.client.control.PersistenceManager.SetValue(OPENER_SCRIPT_COUNT, this.scriptCur);
	com.inq.flash.client.chatskins.SkinControl.getApplicationController().enqueueOpenerText(msg, agentName, sequenceNumber);
};

/**
 * displayScript
 *
 * $type TFun([],TEnum(Void,[]))
 * public function displayScript():Void
 * @public
 * @this com.inq.flash.client.chatskins.OpenerScript
 * @return {void}
 */
com.inq.flash.client.chatskins.OpenerScript.prototype.displayScript = function() {
	this.stopOpenersTimer();
	if(!com.inq.flash.client.chatskins.OpenerScript.bOpenersStopped) {
		this.displayScriptLine();
		this.startOpenersTimer();
	}
};

/**
 * displayadaIntroduction
 *
 * Add adaIntroduction value into invisible div with aria-live="assertive" so the value is spoken.
 *
 * public function displayadaIntroduction():Void
 * @public
 * @this com.inq.flash.client.chatskins.OpenerScript
 * @return {void}
 */
com.inq.flash.client.chatskins.OpenerScript.prototype.displayadaIntroduction = function(adaIntroduction) {
	com.inq.flash.client.chatskins.ChatTextArea.prototype.addBufferedAriaMsg("", adaIntroduction, com.inq.flash.client.chatskins.ChatTextArea.SYSTEM);
};

/**
 * startOpenersTimer
 *
 * $type TFun([],TEnum(Void,[]))
 * private function startOpenersTimer():Void
 * @private
 * @this com.inq.flash.client.chatskins.OpenerScript
 * @return {void}
 */
com.inq.flash.client.chatskins.OpenerScript.prototype.startOpenersTimer = function() {
	if(!com.inq.flash.client.chatskins.OpenerScript.bOpenersStopped && this.scriptCur < this.scriptCnt) {
		this.intervalTimer = new com.inq.utils.Timer(this._delay);
		this.intervalTimer.run = $bind(this,this.displayScript);
	}
};


/**
 * stopOpenersTimer
 *
 * $type TFun([],TEnum(Void,[]))
 * private function stopOpenersTimer():Void
 * @private
 * @this com.inq.flash.client.chatskins.OpenerScript
 * @return {void}
 */
com.inq.flash.client.chatskins.OpenerScript.prototype.stopOpenersTimer = function() {
	if(this.intervalTimer != null) {
		this.intervalTimer.stop();
		this.intervalTimer = null;
	}
};


/**
 * stop
 *
 * $type TFun([{ name => bForce, t => TEnum(Bool,[]), opt => true }],TEnum(Void,[]))
 * public function stop(?bForce:Bool = false):Void
 * @public
 * @this com.inq.flash.client.chatskins.OpenerScript
 * @param {boolean}  bForce 
 * @return {void}
 */
com.inq.flash.client.chatskins.OpenerScript.prototype.stop = function(bForce) {
	if(bForce == null) bForce = false;
	if(bForce) com.inq.flash.client.chatskins.OpenerScript.bOpenersStopped = true;
	
	if(this.intervalTimer == null) return;
	if(this.intervalTimer.stop != null) this.intervalTimer.stop();
	this.intervalTimer = null;
};


/**
 * start
 *
 * $type TFun([{ name => bForce, t => TEnum(Bool,[]), opt => true }],TEnum(Void,[]))
 * public function start(?bForce:Bool = false):Void
 * @public
 * @this com.inq.flash.client.chatskins.OpenerScript
 * @param {boolean}  bForce 
 * @return {void}
 */
com.inq.flash.client.chatskins.OpenerScript.prototype.start = function(bForce) {
	if(bForce == null) bForce = false;
	if(bForce && -1 == com.inq.flash.client.control.PersistenceManager.GetValue(OPENER_SCRIPT_COUNT,-1)) {
		this.reset();
		this.getOpenerScripts();
		return;
	}
	this.getOpenerScripts();
};


/**
 * setDelay
 *
 * $type TFun([{ name => dly, t => TInst(Int,[]), opt => false }],TEnum(Void,[]))
 * public function setDelay(dly:Int):Void
 * @public
 * @this com.inq.flash.client.chatskins.OpenerScript
 * @param {number}  dly 
 * @return {void}
 */
com.inq.flash.client.chatskins.OpenerScript.prototype.setDelay = function(dly) {
	this._delay = dly;
};


/**
 * reset
 *
 * $type TFun([],TEnum(Void,[]))
 * private function reset()
 * @private
 * @this com.inq.flash.client.chatskins.OpenerScript
 * @return {void}
 */
com.inq.flash.client.chatskins.OpenerScript.prototype.reset = function() {
	this.runOnce = false;
	this.scriptLoader = null;
	this.scripts = [];
	this.scriptCnt = 0;
	this.scriptCur = 0;
	this.intervalTimer = null;
	this._delay = 1000 * Std.parseInt("" + Std.string(com.inq.flash.client.control.FlashVars.getValue("openerDelay")));
};

/** @type {string} */
com.inq.flash.client.chatskins.OpenerScript.prototype.DEFAULT_OPENER = "Hello";
/** @private @type {boolean} */
com.inq.flash.client.chatskins.OpenerScript.prototype.force = false;
/** @private @type {boolean} */
com.inq.flash.client.chatskins.OpenerScript.prototype.runOnce = false;
/** @private @type {com.inq.utils.Timer} */
com.inq.flash.client.chatskins.OpenerScript.prototype.intervalTimer = null;
/** @private @type {number} */
com.inq.flash.client.chatskins.OpenerScript.prototype._delay = null;
/** @private @type {number} */
com.inq.flash.client.chatskins.OpenerScript.prototype.scriptCur = 0;
/** @private @type {number} */
com.inq.flash.client.chatskins.OpenerScript.prototype.scriptCnt = 0;
/** @private @type {Array} */
com.inq.flash.client.chatskins.OpenerScript.prototype.scripts = null;
/** @private @type {com.inq.net.URLLoader} */
com.inq.flash.client.chatskins.OpenerScript.prototype.scriptLoader = null;
/** @type {com.inq.flash.client.chatskins.OpenerScript} */
com.inq.flash.client.chatskins.OpenerScript.prototype.__class__ = com.inq.flash.client.chatskins.OpenerScript;
/** @private @static @type {boolean} */
com.inq.flash.client.chatskins.OpenerScript.bOpenersStopped = false;

